export default __webpack_public_path__ + "static/media/event.9bbac919.svg";